module.exports = __webpack_public_path__ + "img/clipboard-import(1).ee7ed260.svg";